/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {GetCacheDataResponse} from "../model/get-cache-data-response";
import {GetCacheMetaDataResponse} from "../model/get-cache-meta-data-response";
import {RemoveCachedValueRequest} from "../model/remove-cached-value-request";

@Injectable({
    providedIn: "root",
})
export class SimCacheService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public clearCache() {
        return super.post<void>(`/api/Cache/ClearCache`, {});
    }

    public getCacheData(cacheKey: string) {
        return super.get<GetCacheDataResponse>(`/api/Cache/GetCacheData`, {cacheKey: cacheKey});
    }

    public getCacheMetaData() {
        return super.get<GetCacheMetaDataResponse[]>(`/api/Cache/GetCacheMetaData`, );
    }

    public removeCachedValue(request: RemoveCachedValueRequest) {
        return super.post<void>(`/api/Cache/RemoveCachedValue`, request);
    }
}